import React, { Component } from 'react';
import { ImagePicker } from 'react-file-picker'

import './css/GapQuestion.css';
import StringUtils from "../../utils/StringUtils";

class GapQuestion extends Component {
    componentWillMount() {
        let gapCount = 0;
        for (const subtask of this.props.subtasks) {
            gapCount += (subtask.match(/{%s}/g) || []).length;
        }
        const subtasks = this.props.subtasks;
        const answers = this.props.correctAnswers || [];
        const question = StringUtils.removeImage(this.props.question);
        const questionImage = StringUtils.getLastImage(this.props.question);
        const wordStates = new Array(subtasks.length).fill('none');
        const inputs = new Array(subtasks.length).fill('');

        this.setState({
            subtasks: subtasks,
            answers: answers,
            question: question,
            questionImage: questionImage,
            wordStates: wordStates,
            inputs: inputs,
            shuffle: this.props.shuffle || false
        });
    }

    setQuestion = (event) => {
        const question = event.target.value;
        this.setState({ question: question });
        this.props.setQuestion(this.props.id, StringUtils.createTextWithImg(question, this.state.questionImage));
    };

    removeQuestionImage = () => {
        this.setState({ questionImage: null });
        this.props.setQuestion(this.props.id, this.props.question);
    };

    deleteQuestion = () => {
        const userIsSure = window.confirm("Na pewno?");
        if (userIsSure) {
            this.props.deleteQuestion(this.props.id);
        }
    };

    handleInput = (subtask, event) => {
        const states = this.state.wordStates;
        const subtasks = this.state.subtasks;
        const inputs = this.state.inputs;

        if(event.key === 'Backspace' && event.target.value === ''){
            if (states[subtask] === 'select') {
                const lastSpace = subtasks[subtask].lastIndexOf(" ");
                if (lastSpace === -1) {
                    subtasks[subtask] = '';
                } else {
                    subtasks[subtask] = subtasks[subtask].substring(0, lastSpace);
                }
                states[subtask] = 'none';
            } else if (states[[subtask]] === 'none') {
                states[subtask] = 'select';
            }
        } else if((event.key === ' ' || event.key === 'Enter') && !StringUtils.isBlank(event.target.value)) {
            let word = event.target.value;
            while (word.startsWith(' ')) {
                word = word.substring(1);
            }
            word = word.substring(0, word.length);
            if (subtasks[subtask] !== '') subtasks[subtask] += ' ';
            subtasks[subtask] += word;
            inputs[subtask] = '';
            states[subtask] = 'none';
        } else {
            inputs[subtask] = event.target.value;
            states[subtask] = 'none';
        }

        this.setState({ inputs: inputs, subtasks: subtasks, states: states }, () => {
            this.saveSubtasks();
        });
    };

    handleInputChange = (subtask, event) => {
        const inputs = this.state.inputs;
        inputs[subtask] = event.target.value;
        if (inputs[subtask] === ' ') {
            inputs[subtask] = '';
        }
        this.setState({ inputs: inputs });
    };

    toggleMarkWord = (subtask, word) => {
        const subtasks = this.state.subtasks;
        let taskWords = subtasks[subtask].split(" ");
        let answers = this.state.answers;
        let answerIndex = 0;
        for (let i = 0; i < subtask; i++) {
            answerIndex += subtasks[i].split("{%s}").length - 1;
        }
        for (let i = 0; i < word; i++) {
            if (taskWords[i] === "{%s}") answerIndex += 1;
        }

        if (taskWords[word] === "{%s}") {
            const wordElement = answers[answerIndex][0].split(" ");
            const strings = taskWords.slice(0, word);
            const endStrings = taskWords.slice(word + 1);
            taskWords = strings.concat(wordElement);
            taskWords = taskWords.concat(endStrings);

            answers.splice(answerIndex, 1);
        } else {
            if (taskWords[word + 1] === "{%s}") {
                answers[answerIndex] = [taskWords[word] + " " + answers[answerIndex][0]];
                taskWords.splice(word, 1);
            } else if (taskWords[word - 1] === "{%s}") {
                answers[answerIndex - 1] = [answers[answerIndex - 1][0] + " " + taskWords[word]];
                taskWords.splice(word, 1);
            } else {
                answers.splice(answerIndex, 0, [taskWords[word]]);
                taskWords[word] = "{%s}"
            }
        }
        subtasks[subtask] = taskWords.join(" ");

        this.props.saveAnswer(this.props.id, answers);
        this.setState({ subtasks: subtasks, answers: answers }, () => {
            this.saveSubtasks();
        });
    };

    saveSubtasks = () => {
        const subtasks = this.state.subtasks;
        this.props.setSubtasks(this.props.id, subtasks);
    };

    handleShuffleChange = () => {
        const shuffle = !this.state.shuffle;
        this.setState({ shuffle: shuffle });
        this.props.setShuffle(this.props.id, shuffle);
    };

    addSubtask = () => {
        const subtasks = this.state.subtasks;
        const inputs = this.state.inputs;
        const wordStates = this.state.wordStates;
        subtasks.push('');
        inputs.push('');
        wordStates.push('none');

        this.setState({
            subtasks: subtasks,
            inputs: inputs,
            wordStates: wordStates
        }, () => {
            this.saveSubtasks();
        });
    };

    removeSubtask = (id) => {
        const subtasks = this.state.subtasks;
        const inputs = this.state.inputs;
        const wordStates = this.state.wordStates;
        const answers = this.state.answers;

        let answerStartIndex = 0;
        for (let i = 0; i < id; i++) {
            answerStartIndex += subtasks[i].split("{%s}").length - 1;
        }
        const answerCount = subtasks[id].split("{%s}").length - 1;

        answers.splice(answerStartIndex, answerCount);
        subtasks.splice(id, 1);
        inputs.splice(id, 1);
        wordStates.splice(id, 1);

        this.props.saveAnswer(this.props.id, answers);
        this.setState({
            subtasks: subtasks,
            inputs: inputs,
            wordStates: wordStates,
            answers: answers
        }, () => {
            this.saveSubtasks();
        });
    };

    addAnswer = (gap) => {
        const answers = this.state.answers;
        answers[gap].push('');
        this.setState({ answers: answers });
        this.props.saveAnswer(this.props.id, answers);
    };

    setGapAnswer = (gap, answer, event) => {
        const answers = this.state.answers;
        answers[gap][answer] = event.target.value;
        this.setState({ answers: answers });
        this.props.saveAnswer(this.props.id, answers);
    };

    removeGapAnswer = (gap, answer) => {
        const answers = this.state.answers;
        answers[gap].splice(answer, 1);
        this.setState({ answers: answers });
        this.props.saveAnswer(this.props.id, answers);
    };

    render() {
        const wordStates = this.state.wordStates;
        let gapIndex = 0;
        const subtasks = this.state.subtasks.map((subtask, taskIndex) => {
            const select = wordStates[taskIndex] === 'select';
            const startingGap = gapIndex;
            let gapLetter = "a".charCodeAt(0);
            const content = subtask
                .split(" ")
                .map((item, index, array) => {
                    const key = "word-" + taskIndex + "-" + index;
                    const selected = array.length - 1 === index && select;
                    if (item === "{%s}") {
                        gapIndex += 1;
                        gapLetter += 1;
                        return (<span key={key}><span className="gap-letter">{String.fromCharCode(gapLetter - 1)}</span><span onClick={() => this.toggleMarkWord(taskIndex, index)} className={"word gap-word " + (selected ? "gap-word-selected" : "")}>{this.state.answers[gapIndex - 1] ? this.state.answers[gapIndex - 1][0] : ''}</span></span>);
                    }
                    return (<span key={key}><span onClick={() => this.toggleMarkWord(taskIndex, index)} className={"word " + (selected ? "gap-word-selected" : "")}>{item}</span></span>);
                });
            const endingGap = gapIndex;
            content.push(<input key={"input-" + taskIndex} className="word-input" type="text" value={this.state.inputs[taskIndex]} onChange={(event) => this.handleInputChange(taskIndex, event)} onKeyDown={(event) => this.handleInput(taskIndex, event)} />)
            content.push(<button className="btn-square" onClick={() => this.removeSubtask(taskIndex)}><i className="far fa-trash-alt" /></button>);

            const answers = [];
            gapLetter = "a".charCodeAt(0);
            for (let i = startingGap; i < endingGap; i++) {
                const answerGroup = [];
                for (let j = 0; j < (this.state.answers[i] ? this.state.answers[i].length : 0); j++) {
                    answerGroup.push(<div key={"answer-" + taskIndex + "-" + i + "-" + j}><input
                                        onChange={(event) => this.setGapAnswer(i, j, event)}
                                        className="word-input"
                                        type="text"
                                        value={this.state.answers[i][j]} />
                        <button className="btn-square" onClick={() => this.removeGapAnswer(i, j)}><i className="far fa-trash-alt" /></button>
                    </div>);
                }
                answers.push(<span key={"answers-" + i}><div className="gap-letter-header">Luka {String.fromCharCode(gapLetter)}</div>{answerGroup}<div><button className="btn-square" onClick={() => this.addAnswer(i)}><i className="fas fa-plus" /></button></div></span>);
                gapLetter += 1;
            };

            return (
                <div key={"subtask-" + taskIndex} className="subtask">
                    {taskIndex + 1}. {content}
                    <div>{answers}</div>
                </div>
            );
        });

        const questionImage = (<img alt="external" className="external-image" src={this.state.questionImage} />);

        return (
            <div className="task-block gap-question-edit">
                {this.props.isFirst ? '' : <button className="btn-square" onClick={this.props.moveUp}><i className="fas fa-arrow-up"></i></button>}
                {this.props.isLast ? '' : <button className="btn-square" onClick={this.props.moveDown}><i className="fas fa-arrow-down"></i></button>}
                <div className="question-number">Pytanie {this.props.number} ({subtasks.length} pkt.)</div>
                <div className="question">
                    <input type="text" placeholder="Pytanie" value={this.state.question} className="question-value" onChange={this.setQuestion} />
                    {this.state.questionImage != null ? questionImage : ''}
                    <ImagePicker
                        extensions={['jpg', 'jpeg', 'png']}
                        dims={{ minWidth: 100, minHeight: 100 }}
                        onChange={base64EncodedString => this.setState({ questionImage: base64EncodedString })}
                        onError={errMsg => console.log(errMsg)}
                        style={{ display: "inline-block" }}
                    >
                        <button className="btn-square"><i className="far fa-image" /></button>
                    </ImagePicker>
                    {this.state.questionImage != null ? <button className="btn-square" onClick={this.removeQuestionImage}><i className="fas fa-ban" /></button> : ''}
                    <button className="btn-square" onClick={this.deleteQuestion}><i className="far fa-trash-alt" /></button>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input type="checkbox" onChange={this.handleShuffleChange} checked={this.state.shuffle} />
                        <span className="checkmark"/>
                        <label>
                            Losowa kolejność
                        </label>
                    </label>
                </div>
                <div className="subtasks">
                    {subtasks}
                    <button className="btn-square" onClick={this.addSubtask}><i className="fas fa-plus" /> Dodaj podpunkt</button>
                </div>
            </div>
        );
    }
}

export default GapQuestion;